import React from 'react';
import { Button } from '../../../components/ui';
import type { EmployeeView } from '../shared';

interface AssignmentStripProps {
  employee: EmployeeView;
  projectName: string;
  linkedToProject: boolean;
  onViewMandate?: () => void;
}

export const AssignmentStrip: React.FC<AssignmentStripProps> = ({
  employee,
  projectName,
  linkedToProject,
  onViewMandate,
}) => (
  <div className="grid grid-cols-2 gap-px rounded-xl border border-border bg-border md:grid-cols-5">
    <Cell
      label="Project"
      value={projectName}
      sub={linkedToProject ? 'linked through project resources' : 'available for assignment proposal'}
    />
    <Cell
      label="Team"
      value={linkedToProject ? (employee.team ?? '—') : '—'}
      sub={linkedToProject && employee.team ? 'project team' : ''}
    />
    <Cell
      label="Manager"
      value={employee.manager ?? '—'}
      sub={employee.manager === 'You' ? 'reports to you' : 'reports daily'}
    />
    <Cell
      label="Workstream"
      value={linkedToProject ? (employee.workstream ?? '—') : '—'}
      sub={linkedToProject ? (employee.currentChange ?? 'no change linked') : 'not linked to this project'}
    />
    <Cell
      label="Mandate"
      value={
        employee.mandate ? (employee.mandate.length > 90 ? `${employee.mandate.slice(0, 90)}…` : employee.mandate) : '—'
      }
      sub={
        onViewMandate ? (
          <Button size="sm" variant="ghost" onClick={onViewMandate}>
            View full
          </Button>
        ) : (
          ''
        )
      }
      valueClassName="text-xs font-normal text-body leading-snug"
    />
  </div>
);

const Cell: React.FC<{
  label: string;
  value: React.ReactNode;
  sub: React.ReactNode;
  valueClassName?: string;
}> = ({ label, value, sub, valueClassName }) => (
  <div className="bg-surface px-3 py-2.5">
    <div className="font-mono text-[10px] uppercase tracking-wider text-faint">{label}</div>
    <div className={valueClassName ?? 'mt-1 text-sm font-medium text-heading'}>{value}</div>
    <div className="mt-0.5 text-[11px] text-muted">{sub}</div>
  </div>
);
